import type { OrganizationAccess } from '@hotjar/organization';

const organizationAccesses: OrganizationAccess[] = ['admin', 'read', 'write'];

export function isValidOrganizationAccess(
  maybeOrganizationAccess: string,
): maybeOrganizationAccess is OrganizationAccess {
  return (
    !!maybeOrganizationAccess &&
    organizationAccesses.includes(maybeOrganizationAccess as OrganizationAccess)
  );
}
